import React, { useContext } from 'react'
import classNames from 'classnames'
import CallButton from '~/components/common/CallButton'
import { Campaign, CampaignManagerContext } from '~/service/CampaignManager'
import { FormattedMessage } from '~/translations/utils'
import MainContent from '../MainContent'

const List: React.FC = ({}) => {
  const context = useContext(CampaignManagerContext)

  const campaigns = context.campaigns.filter(item => !item.disabled)

  return (
    <MainContent>
      <div className="phone-campaign-list">
        {campaigns.length ? (
          campaigns.map(campaign => (
            <Item campaign={campaign} key={campaign.id} />
          ))
        ) : (
          <div className="list-empty">
            <FormattedMessage id="campaigns / empty" />
          </div>
        )}
      </div>
    </MainContent>
  )
}

type ItemProps = {
  campaign: Campaign
}

const Item: React.FC<ItemProps> = ({ campaign }) => {
  const context = useContext(CampaignManagerContext)
  const left = campaign.totalCount - campaign.calledCount
  const done = campaign.calledCount

  return (
    <div
      className={classNames('phone-campaign-list-item', {
        'is-inProgress': left,
      })}
    >
      <div className="phone-campaign-list-item-main">
        <div className="phone-campaign-list-item-main-title">
          {campaign.name.replace(/\-/g, ' ')}
        </div>
        <div className="phone-campaign-list-item-main-details">
          <div>
            <FormattedMessage id="campaign / done" />: <strong>{done}</strong>
          </div>
        </div>
      </div>

      {context.loading && campaign.state == 'started' ? (
        <span className="fa fa-spinner-third fa-spin" />
      ) : (
        <>
          {left && ['stopped'].includes(campaign.state) ? (
            <button
              onClick={() => context.start(campaign.id)}
              className="phone-campaign-list-item-start"
            >
              <FormattedMessage id="campaign / start" />
              <span className="fa fa-phone" />
            </button>
          ) : null}

          {left && ['started'].includes(campaign.state) ? (
            <CallButton stop onClick={context.stop} />
          ) : null}
        </>
      )}

      {left ? (
        <div className="phone-campaign-list-item-progress">
          <div
            style={{
              width: `${(1 - left / campaign.totalCount) * 100}%`,
            }}
          />
        </div>
      ) : null}
    </div>
  )
}

export default List
